<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <page-header>Groups</page-header>

            <kiosk-team-groups-table :teamId="props.teamId" />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import PageHeader from '~/components/general/PageHeader.vue';
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import KioskTeamGroupsTable from './KioskTeamGroupsTable.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});
</script>
